import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import styles from "./index.module.scss";
import error_picture from "@/assets/icons/svg/error_picture.svg";
import classNames from "classnames";
import { NewBaseIcon } from "../NewBaseIcon";
export const BaseImage = /*#__PURE__*/forwardRef((param, ref) => {
  let {
    src,
    alt,
    className,
    style,
    imgStyle,
    imgClass = "",
    loadingComponent,
    errorComponent,
    loader,
    onLoad,
    onError,
    banImageCopy = false,
    ...otherProps
  } = param;
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const handleImageLoad = ev => {
    if (typeof onLoad === "function") {
      onLoad(ev);
    }
    setIsLoading(false);
    setIsError(false);
  };
  const handleImageError = ev => {
    if (typeof onError === "function") {
      onError(ev);
    }
    setIsLoading(false);
    setIsError(true);
  };
  const defaultLoader = /*#__PURE__*/_jsx("div", {
    className: styles.loading
  });
  const defaultError = /*#__PURE__*/_jsx("div", {
    className: styles.error,
    children: /*#__PURE__*/_jsx(NewBaseIcon, {
      size: 36,
      icon: error_picture
    })
  });
  const clsNames = classNames(styles.container, className);
  return /*#__PURE__*/_jsxs("div", {
    className: clsNames,
    style: style,
    ref: ref,
    children: [/*#__PURE__*/_jsx("img", {
      src: src,
      alt: alt,
      onLoad: handleImageLoad,
      onError: handleImageError,
      className: classNames({
        ban_img_copy: banImageCopy,
        [imgClass]: !!imgClass
      }),
      style: {
        ...imgStyle
      },
      loading: "lazy",
      draggable: !banImageCopy,
      ...otherProps
    }), loader && isLoading && (loadingComponent || defaultLoader), isError && (errorComponent || defaultError)]
  });
});